export default {"src":"/_next/static/media/eatfirst-logo.59e94bf0.svg","height":90,"width":169};